(function () {
  const params = new URLSearchParams(window.location.search);

  // Only run when the customer arrived through a Make An Offer link.
  if (params.get('make_offer') !== '1') {
    return;
  }

  let attempts = 0;
  const maxAttempts = 100;

  function openMakeOffer() {
    const offerButton = document.getElementById(
      'ma-make-an-offer-open-button'
    );

    if (offerButton) {
      offerButton.click();

      // Remove ?make_offer=1 so refreshing the page
      // does not automatically reopen the offer window.
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('make_offer');

      window.history.replaceState(
        {},
        document.title,
        cleanUrl.pathname + cleanUrl.search + cleanUrl.hash
      );

      return;
    }

    attempts += 1;

    if (attempts < maxAttempts) {
      window.setTimeout(openMakeOffer, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openMakeOffer, {
      once: true
    });
  } else {
    openMakeOffer();
  }
})();